import styled from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';

const S = {};

S.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 280px;
  flex: 0 0 1;
  max-height: 100%;
  margin-right: ${theme('spacing.lg')};
  padding: ${theme('spacing.md')};
  border-radius: ${theme('borderRadius.md')};
  box-shadow: ${theme('shadow.xs')};
  background-color: ${ifProp(
    'isDraggingOver',
    palette('bgColumnBoardDragging'),
    palette('bgColumnBoard')
  )};
  transition: ${theme('transition')};
  &:last-child {
    margin-right: 0;
  }

  ${theme('components.ColumnBoard')}
`;

S.WrapperScroll = styled.div`
  display: flex;
  margin-top: 10px;
  overflow: hidden;
`;

S.Scroll = styled.div`
  flex: 1;
  padding: 2px;
  overflow: auto;
`;

export default S;
